
import React from 'react'
import facebook from './svgs/facebook.svg'
import { BaseIcon } from './_base'

export const FacebookIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {facebook} {...{fontSize,size,...sx}} />
    )
}
